













































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import DlgAdNew from '../../../modules/ads/_components/DlgAdNew.vue';
import DlgAdDelete from '../../../modules/ads/_components/DlgAdDelete.vue';
import DlgAdEdit from '../../../modules/ads/_components/DlgAdEdit.vue';
import Card from '@/components/material/Card.vue';
import ImageUploader from '@/modules/files/_components/imageUploader.vue';

@Component({
  components: {
    ImageUploader,
    DlgAdNew,
    DlgAdDelete,
    DlgAdEdit,
    Card,
  },
})
export default class AdsList extends Vue {
  public $refs!: {
    image: any,
  };
  @Prop(String) private readonly id!: string;
  @Action('articles/upload') private upload!: any;
  @Action('articles/create') private create!: any;
  @Action('articles/setNewArticle') private setNewArticle!: any;
  @Action('articles/readOne') private readOne!: any;
  @Action('articles/update') private update!: any;

  @Getter('articles/one') private article!: any;

  private loading: boolean = false;
  private localArticle: any = {};

  private async created() {
    this.loading = true;
    await this.readOne({id: this.id});
    this.localArticle = JSON.parse(JSON.stringify(this.article));
    this.loading = false;
  }

  private async updateArticle() {
    this.loading = true;
    const url = await this.$refs.image.doUpload();
    const res = await this.update({...this.localArticle, image: url});
    this.loading = false;
    if (res) {
      this.$router.back();
    }
  }
}
